import React, { memo, useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { message, Modal } from 'antd';

import bytes from 'bytes';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { imgLocalUrl, logNative } from '../../utils/utils';
import { PCStoreJsBridge } from '../../nativeapi';
import { CONTEXT } from '../../config';

import defaultImg from '../../static/default.svg';
import styles from './UninstLineCard.module.less';

import { logPostInfo, logging } from '../../actions/log';
import { setMenuSpot, setDetailCommentVisible } from '../../actions/layout';
import { getLocalSoft } from '../../actions/native';
import { addUninstall, cancelUninstall } from '../../actions/uninstall';
import { mySoftKeys } from '../../constants/storageKeys';
import ResidualSoft from './ResidualSoft';
import Rate from '../../components/Rate/Rate';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

export default memo(props => {
  const { soft, logInfo, tempResidualList, softInfo = {} } = props;
  const dispatch = useDispatch();
  const [tempResidualInfo, setTempResidualInfo] = useState(null);
  const logInfoData = useSelector(selectLogInfo);
  const installedSoft = useSelector(selectInstalledSoft);
  const uninstallSoftList = useSelector(selectUninstallSoft);

  const [uninstallSoft, setUninstallSoft] = useState(null);
  const [isShowSpot, setIsShowSpot] = useState(false);
  const [visible, setVisible] = useState(false);
  const [uninstallSoftInfo, setUninstallSoftInfo] = useState(null);
  //
  const [userGrade, setUserGrade] = useState(0);

  const addDesktopEl = useRef(null);

  // 后期修补 卸载根目录的bug
  const [isCantUninstall, setIsCantUninstall] = useState(true);

  /**
   * 设置初始化用户评分
   */
  useEffect(() => {
    if (
      soft &&
      (soft.SoftID || soft.softID) &&
      softInfo &&
      softInfo[soft.SoftID] &&
      softInfo[soft.SoftID].userGrade
    ) {
      setUserGrade(softInfo[soft.SoftID].userGrade);
    }
    if (soft && soft.androidType === '1') {
      setUserGrade(soft.userGrade);
    }
  }, [soft, softInfo]);

  useEffect(() => {
    message.config({ top: 318, duration: 2 });
    const found = uninstallSoftList.find(
      v =>
        (soft.androidType !== '1' && v.softGUID === soft.softGUID) ||
        (soft.androidType === '1' && v.packageName === soft.packageName),
    );
    setUninstallSoft(found || null);
  }, [uninstallSoftList]);

  useEffect(() => {
    const data =
      tempResidualList &&
      tempResidualList.find(item => {
        return item.softGUID === soft.softGUID;
        // && item.isx64 === soft.isx64;
      });
    setTempResidualInfo(data);
  }, [tempResidualList, soft]);
  // 展示设置小红点
  useEffect(() => {
    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT) || '';
    if (soft && soft.softID) {
      setIsShowSpot(spotSoftStr.indexOf(soft.softID) > -1);
    }
  }, [installedSoft, soft]);

  const handleOpen = useCallback(
    softInfo => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID,
        softName: softInfo.softName,
        softType: 'o',
        url: softInfo.downLoadUrl || softInfo.downloadUrl,
        type: 'o',
      };
      // 按钮点击打桩
      logParam2.type = 'o';
      if (softInfo.androidType === '1') {
        logParam2.softType = '1';
        logParam2.softid = softInfo.packageName;
        logParam2.versionCode = softInfo.versionCode;
        logParam2.softName = softInfo.softName;
        // 首先判断模拟器是否已经安装。
        PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
          if (SIMInstalled) {
            PCStoreJsBridge.openAndroidSoft({ ...softInfo, logInfo: logParam2 }).then(isOpen => {
              if (isOpen !== true) {
                message.info('软件运行失败！');
                dispatch(getLocalSoft());
              }
            });
          } else {
            // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
            dispatch(getLocalSoft());
          }
        });

        // 展示取消小红点
        // 是否为第一次打开，取消小红点
        logParam2.type = '0';
        const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const spotSoft = spotSoftStr.split(',');
        if (spotSoft.indexOf(softInfo.softID) > -1) {
          spotSoft.splice(spotSoft.indexOf(softInfo.softID), 1);
          localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSoft.join(','));
          setIsShowSpot(false);
          logParam2.type = '1';
        }

        // 更新菜单上的小红点
        const spotSoftStrNew = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const installedSpotSoft = installedSoft.find(
          softItem => softItem.androidType === '1' && spotSoftStrNew.indexOf(softItem.softID) > -1,
        );
        dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.softID));
      } else {
        logParam2.softType = '0';
        logParam2.softid = softInfo.SoftID;
        logParam2.softName = softInfo.displayName;
        PCStoreJsBridge.openSoft(softInfo).then(isOpen => {
          if (isOpen !== true) {
            message.info('软件运行失败！');
            dispatch(getLocalSoft());
          }
        });
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Open',
          label: '',
          param2: logParam2,
          param3: softInfo.bizInfo || '{}',
        }),
      );
    },
    [dispatch, logInfoData],
  );

  const handleUninstall = useCallback(
    (softInfo, uninstallType) => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID || softInfo.SoftID || '',
        softname: softInfo.softGUID,
        softType: softInfo.androidType === '1' ? '1' : '0',
      };
      if (softInfo.androidType === '1') {
        logParam2.softid = softInfo.packageName;
      }
      // 卸载页面-继续卸载
      if (uninstallType === 'modal') {
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Continue',
            label: '',
            param2: logParam2,
          }),
        );
      }
      // 关闭弹窗
      setVisible(false);
      // 添加卸载任务，开始卸载软件
      logNative(
        `开始调用卸载软件，添加卸载任务, ${JSON.stringify(logParam2)}`,
        softInfo,
        true,
        true,
      );
      dispatch(addUninstall(softInfo));
      if (softInfo.androidType === '1') {
        PCStoreJsBridge.uninstallAndroidSoft(softInfo).then(succ => {
          if (succ !== 'true') {
            dispatch(cancelUninstall(softInfo));
          }
        });
      } else {
        PCStoreJsBridge.uninstallSoft(softInfo);
      }
    },
    [dispatch, logInfoData],
  );

  const handleUnInstallOper = useCallback(softInfo => {
    const logParam2 = {
      source: 'Mysofts',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: softInfo.softID || softInfo.SoftID || '',
      softname: softInfo.softGUID,
      softType: softInfo.androidType === '1' ? '1' : '0',
    };
    if (softInfo.androidType === '1') {
      logParam2.softid = softInfo.packageName;
    }
    // 卸载页面-点击创建快捷方式-打桩
    dispatch(
      logging({
        category: 'C',
        action: 'T_Cleaner',
        label: '',
        param2: logParam2,
      }),
    );
    if (!softInfo.title) {
      handleUninstall(softInfo);
      return;
    }
    setUninstallSoftInfo(softInfo);
    setVisible(true);
    // 打开卸载保护弹窗打桩
    dispatch(
      logging({
        category: 'P',
        action: 'Uninstall_Protect',
        label: '',
        param2: logParam2,
      }),
    );
  });

  const handleCancelModal = useCallback(
    uninstallType => {
      setVisible(false);
      if (uninstallType === 'modal') {
        // 通过弹窗里面暂不卸载 关闭卸载保护弹窗
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Cancel',
            label: '',
            param2: {
              source: 'Mysofts',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: soft.softID || soft.SoftID || '',
              softname: soft.softGUID,
              softType: soft.androidType === '1' ? '1' : '0',
            },
          }),
        );
        return;
      }
      // 直接关闭卸载保护弹窗
      dispatch(
        logging({
          category: 'C',
          action: 'Uninstall_Protect_Close',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softID || soft.SoftID || '',
            softname: soft.softGUID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
        }),
      );
    },
    [logInfoData],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'Mysofts';
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  /**
   * 添加临时逻辑判断, 后期修补 卸载根目录的bug
   */
  const judgeChildPath = pathStr => {
    if (pathStr) {
      let pathList = pathStr.split(/\\/);
      let startIndex = pathList.findIndex(item => item === '..');
      while (startIndex > -1) {
        pathList.splice(startIndex - 1, 2);
        startIndex = pathList.findIndex(item => item === '..');
      }
      pathList = pathList.filter(item => item && !/\.exe$/.test(item));
      return pathList.length > 1;
    }
    return false;
    // if (pathStr) {
    //   const instArr = pathStr.split('\\');
    //   const backArr = instArr.filter(item => item === '..');

    //   if (instArr.length === 1) {
    //     return false;
    //   }
    //   if (instArr.length === 2 && (instArr[1].indexOf('.exe') > -1 || instArr[1] === '')) {
    //     return false;
    //   }
    //   if (instArr.length === 3 && (instArr[1] === '..' || instArr[2].indexOf('.exe') > -1)) {
    //     return false;
    //   }
    //   if (instArr.length > 3 && instArr.length - 3 < backArr.length * 2) {
    //     return false;
    //   }
    //   return true;
    // }
    // return false;
  };

  useEffect(() => {
    if (!soft.installString && !soft.MainExePath) {
      return;
    }
    if (!judgeChildPath(soft.installString, soft) && !judgeChildPath(soft.MainExePath, soft)) {
      setIsCantUninstall(false);
      logNative(`卸载目录不常规，疲敝这个软件 ${soft}`, {}, true, true);
    }
  }, [soft]);

  const handleRate = useCallback(
    e => {
      const handleStar = parseInt(e.target.getAttribute('star'));
      dispatch(
        setDetailCommentVisible({
          visible: true,
          soft,
          handleStar,
          successFunc: updateList,
          time: +new Date(),
        }),
      );
    },
    [dispatch, soft, softInfo],
  );

  const updateList = useCallback(() => {
    dispatch(getLocalSoft());
    dispatch(setDetailCommentVisible({}));
  }, [dispatch]);

  if (
    tempResidualInfo &&
    !judgeChildPath(soft.installString) &&
    !judgeChildPath(soft.MainExePath)
  ) {
    return null;
  }

  return (
    <>
      {soft.androidType === '1' ? (
        <div
          data-softtag={`${soft.softGUID}-${soft.isx64}`}
          className={!uninstallSoft ? styles.line_soft : styles.line_soft_disable}
        >
          <div className="soft_logo">
            <img src={soft.logoFile} alt="" />
            <div className="icon alogo" />
            {false && (
              <div className="soft_add_desktop" ref={addDesktopEl}>
                创建桌面图标
              </div>
            )}
          </div>
          <div className="soft_info">
            {soft.packageName ? (
              <Link
                className="soft_info_name"
                to={{
                  pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode ||
                    0}/${soft.bizInfo || '{}'}`,
                }}
                onClick={() => {
                  handleSoftCard(soft);
                }}
              >
                {soft.softName}
              </Link>
            ) : (
              <div className="soft_info_name">{soft.softName}</div>
            )}
            <div className="soft_info_desc">{soft.publisher}</div>
          </div>
          <div className="soft_time">
            {!soft.installdate && '未知'}
            {soft.installdate && dayjs(soft.installdate).format('YYYY-MM-DD')}
          </div>
          <div className="soft_size">
            {bytes(Number(soft.estimateSize), { unitSeparator: ' ' })}
          </div>
          <div
            className={soft && soft.packageName ? 'soft_score' : 'soft_score_'}
            onClick={e => {
              soft && soft.packageName && handleRate(e);
            }}
          >
            {soft && soft.packageName && (
              <>
                <div className="soft_score_text">
                  {Number(userGrade) === 0 ? '暂未评分' : '我的评分'}
                </div>
                <Rate score={Number(userGrade).toFixed(1)} rateInfo={{ isNeedClick: true }} />
              </>
            )}
            {/* {soft && soft.packageName && (
              <Rate score={Number(soft.userGrade).toFixed(1)} rateInfo={{ isNeedClick: true }} />
            )} */}
          </div>
          <div className="soft_operation">
            <div
              className="uninstall_btn"
              onClick={() => {
                if (!uninstallSoft) {
                  handleUnInstallOper(soft);
                }
              }}
            >
              {!uninstallSoft ? '卸载' : '卸载中'}
            </div>
            <div
              className="open_btn"
              onClick={() => {
                if (!uninstallSoft) {
                  handleOpen(soft);
                }
              }}
            >
              <span>打开</span>
              {isShowSpot && <span className="open_btn_spot" />}
            </div>
          </div>
        </div>
      ) : (
        <div
          data-softtag={`${soft.softGUID}-${soft.isx64}`}
          className={
            !uninstallSoft || tempResidualInfo ? styles.line_soft : styles.line_soft_disable
          }
        >
          {!tempResidualInfo && (
            <>
              <div className="soft_logo">
                <img
                  src={
                    soft.logoFile || (soft.displayIcon ? imgLocalUrl(soft.displayIcon) : defaultImg)
                  }
                  alt=""
                />
              </div>
              <div className="soft_info">
                {soft.SoftID ? (
                  <Link
                    className="soft_info_name"
                    to={`${CONTEXT}/detail/soft/${soft.SoftID}/${soft.bizInfo || '{}'}`}
                    onClick={() => {
                      handleSoftCard(soft);
                    }}
                  >
                    <div className="soft_info_name" title={soft.displayName}>
                      {soft.displayName}
                    </div>
                  </Link>
                ) : (
                  <div className="soft_info_name_" title={soft.displayName}>
                    {soft.displayName}
                  </div>
                )}
                <div className="soft_info_desc" title={soft.publisher}>
                  {soft.publisher}
                </div>
              </div>
              <div className="soft_time">{dayjs(soft.installdate).format('YYYY-MM-DD')}</div>
              <div className="soft_size">
                {soft.estimateSize !== '0'
                  ? bytes(Number(soft.estimateSize), { unitSeparator: ' ' })
                  : '未知'}
              </div>
              <div
                className={soft && soft.SoftID ? 'soft_score' : 'soft_score_'}
                onClick={e => {
                  soft && soft.SoftID && handleRate(e);
                }}
              >
                {soft && soft.SoftID && (
                  <>
                    <div className="soft_score_text">
                      {Number(userGrade) === 0 ? '暂未评分' : '我的评分'}
                    </div>
                    <Rate score={Number(userGrade).toFixed(1)} rateInfo={{ isNeedClick: true }} />
                  </>
                )}
              </div>
              <div className="soft_operation">
                {isCantUninstall ? (
                  <div
                    className="uninstall_btn"
                    onClick={() => {
                      if (!uninstallSoft) {
                        handleUnInstallOper(soft);
                      }
                    }}
                  >
                    {!uninstallSoft ? '卸载' : '卸载中'}
                  </div>
                ) : (
                  <div className="uninstall_btn_disable">卸载</div>
                )}
                {soft.MainExePath ? (
                  <div
                    className="open_btn"
                    onClick={() => {
                      if (!uninstallSoft) {
                        handleOpen(soft);
                      }
                    }}
                  >
                    打开
                  </div>
                ) : (
                  <div className="open_btn_disable">打开</div>
                )}
              </div>
            </>
          )}
          {tempResidualInfo && (
            <ResidualSoft
              residualInfo={{
                ...tempResidualInfo,
                logoFile:
                  (softInfo[soft.SoftID || soft.softid] &&
                    softInfo[soft.SoftID || soft.softid].logoFile) ||
                  tempResidualInfo.logoFile,
              }}
              soft={{
                ...tempResidualInfo,
                ...soft,
                logoFile:
                  (softInfo[soft.SoftID || soft.softid] &&
                    softInfo[soft.SoftID || soft.softid].logoFile) ||
                  tempResidualInfo.logoFile,
              }}
            />
          )}
        </div>
      )}
      <Modal
        visible={visible}
        style={{
          position: 'fixed',
          top: '250px',
          left: 'calc(50% - 180px)',
          zIndex: 1000,
          width: '360px',
          height: '180px',
          padding: '12px 15px',
          background: '#fff',
          boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.3)',
          borderRadius: '4px',
          boxSizing: 'border-box',
        }}
        bodyStyle={{
          padding: 0,
        }}
        wrapClassName={styles.modalWrap}
        mask
        maskClosable={false}
        width={360}
        centered
        destroyOnClose
        footer={null}
        closable={false}
      >
        <div className={styles.modal_header}>
          <span className={styles.title}>温馨提示</span>
          <i
            className={classNames('iconfont icon-close', styles.icon_close)}
            onClick={() => {
              handleCancelModal();
            }}
          />
        </div>
        <div className={styles.modal_content}>{uninstallSoftInfo && uninstallSoftInfo.title}</div>
        <div className={styles.modal_button}>
          <div
            className={classNames(styles.button, styles.install)}
            onClick={() => {
              handleUninstall(uninstallSoftInfo, 'modal');
            }}
          >
            继续卸载
          </div>
          <div
            className={classNames(styles.button, styles.uninstall)}
            onClick={() => {
              handleCancelModal('modal');
            }}
          >
            暂不卸载
          </div>
        </div>
      </Modal>
    </>
  );
});
